export default __webpack_public_path__ + "static/media/icon-dietetyczny bestseller.878f4502.svg";